import ThemeInterface from '../ThemeInterface';

const core = {
  brand: '#000',
  accent: '#f7a193',
  foreground: '#333',
  neutral: '#ccc',
  border: '#c4c4c4',
  
  boldFontWeight: 600,
  
  typography: {
    primary: 'WorkSans, LFRebrand',
    secondary: 'WorkSans, LFRebrand',
  },
};

export default {
  core,
  header: {
    logoHeight: 18,
    mobileLogoHeight: 15,
    marginTop: 16,
    marginBottom: 16,
  },
  sectionHeader: {
    fontWeight: 600,
  },
  button: {
    letterSpacing: 0.2,
    isUppercase: true,
    borderRadius: 6,
    primary: {
      backgroundColour: core.brand,
      colourOnHover: core.brand,
      backgroundColourOnHover: core.accent,
      hasUnderlineOnHover: true,
    },
    secondary: {
      colour: core.brand,
      borderColour: core.brand,
      
      colourOnHover: core.brand,
      backgroundColourOnHover: '#fdf0ee',
      borderColourOnHover: core.brand,
    },
  },
  completePage: {
    referralCodeFontColor: core.brand,
    referralCodeBorderRadius: 6,
  },
  optionalDeliveryBasketItem: {
    backgroundColour: '#fff',
  }
} as ThemeInterface;
